import apiClient from '@u/apiClient'
import actionsElys from '@/store/modules/partner/actions.elys'
import actionsEnaos from '@/store/modules/partner/actions.enaos'
import actionsGuestSuite from '@/store/modules/partner/actions.guestsuite'
import CremagestAvailabilityController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CremagestAvailabilityController'
import GetPlacesByWikiCity from '@/wayfinder/actions/App/Http/Controllers/Partners/Enaos/GetPlacesByWikiCity'
import CheckEnaosCredentialController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/CheckEnaosCredentialController'
import GetEnaosHumanResourcesController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/GetEnaosHumanResourcesController'
import GetEnaosFunerariumsController from '@/wayfinder/actions/App/Http/Controllers/FuneralHomePartner/GetEnaosFunerariumsController'

export default {
  ...actionsElys,
  ...actionsEnaos,
  ...actionsGuestSuite,
  // region fetch
  getCremagestAvaiability({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CremagestAvailabilityController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosPlacesByWikiCity({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPlacesByWikiCity.get(), { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkCredentialsEnaos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CheckEnaosCredentialController.get(), { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getEnaosHumanResources({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetEnaosHumanResourcesController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getEnaosFunerariums({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetEnaosFunerariumsController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
